import { TYPE_COLLECTION } from './input-types';
import { RESIDENTIAL_OR_COMMERCIAL } from '../constants';

export const id = RESIDENTIAL_OR_COMMERCIAL;
export const apiKey = 'ResidentialIndicator';
export const type = TYPE_COLLECTION;

export const residentialOrCommercial = {
  id,
  apiKey,
  type,
};
